if (!customElements.get("manmade-order-tracking")) {
  customElements.define(
    "manmade-order-tracking",
    class OrderTracking extends HTMLElement {
      constructor() {
        super();

        this.enFormatter = this.makeDateFormatter("en");
        this.frFormatter = this.makeDateFormatter("fr");

        if (this.getUrlParamsByName("_m_id")) {
          this.redirectToMalomoTrackingPage();
        }

        this.queryParam = this.getUrlParamsByName("query") || this.getUrlParamsByName("search");
        if (this.queryParam) {
          this.displayTrackingStatus();
        } else {
          this.displayForm();
        }
      }

      getUrlParamsByName(name, url = window.location.href) {
        const params = new URL(url).searchParams;
        return params.get(name);
      }

      displayForm() {
        this.hideSpinner();

        const form = this.querySelector("form");
        form.classList.remove("mm-hidden");
      }

      displayTrackingStatus() {
        this.queryOrderStatus(this.queryParam)
          .then((contents) => contents.data.shipmentSearch?.shipments?.[0])
          .then((contents) => this.renderContents(contents));
      }

      renderContents(contents) {
        if (contents === undefined) {
          this.displayForm();

          const notFoundContainer = this.querySelector(".mm-error-not-found");

          notFoundContainer.classList.remove("mm-hidden");
        } else {
          this.hideSpinner();

          const events = contents.events;
          const carrierName = contents.carrierName;
          const trackingCode = contents.trackingCode;
          const trackingUrl = contents.trackingUrl;

          const trackingBar = this.querySelector(".mm-status-tracking").children;
          const statusContainer = this.querySelector(".mm-status");
          statusContainer.classList.remove("mm-hidden");

          const statusDetails = contents["statusDetails"];
          const isDelivered =
            statusDetails &&
            (statusDetails.substatus === "delivered" || statusDetails.substatus === "pickup_available");
          const isReturned =
            (statusDetails && statusDetails.substatus === "return_to_sender") ||
            events.find((event) => event.substatus == OrderTracking.RETURN_TO_SENDER);

          if (isDelivered) {
            let statusDateHtmlElement = this.querySelector(".mm-status-details__date");
            let date = new Date(statusDetails.date);

            statusDateHtmlElement.innerHTML = `
              <div>
                <span class="mm-subtitle">
                  ${window.orderTracking.deliveryDate}
                </span>
                <span class="mm-date" data-locale="en">
                  ${this.enFormatter.format(date)}
                </span>
                <span class="mm-date" data-locale="fr">
                  ${this.frFormatter.format(date)}
                </span>
              </div>
            `;
          } else if (!isReturned && contents.eta && contents.eta !== "pending") {
            let statusDateHtmlElement = this.querySelector(".mm-status-details__date");
            let date = new Date(contents.eta.substr(0, 10) + "T08:00:00.000Z");

            statusDateHtmlElement.innerHTML = `
              <div>
                <span class="mm-subtitle">
                  ${window.orderTracking.eta}
                </span>
                <span class="mm-date" data-locale="en">
                  ${this.enFormatter.format(date)}
                </span>
                <span class="mm-date" data-locale="fr">
                  ${this.frFormatter.format(date)}
                </span>
              </div>
            `;
          } else if (contents.eta === "pending") {
            let statusDateHtmlElement = this.querySelector(".mm-status-details__date");

            statusDateHtmlElement.innerHTML = `
              <div>
                <span class="mm-subtitle">
                  ${window.orderTracking.eta}
                </span>
                <span class="mm-date" style="display:block;">
                  ${window.orderTracking.eta_pending}
                </span>
              </div>
            `;
          }

          let status = null;
          if (!statusDetails || statusDetails.substatus == "information_received") {
            status = "fulfilled";
          } else if (statusDetails.substatus == "delivered" || statusDetails.substatus == "pickup_available") {
            status = "delivered";
          } else if (statusDetails.substatus == "out_for_delivery") {
            status = "out_for_delivery";
          } else if (statusDetails.substatus == "delayed") {
            status = "delayed";
          } else if (statusDetails.substatus == "delivery_attempted") {
            status = "delivery_attempted";
          } else if (isReturned) {
            status = "return_to_sender";
          } else if (statusDetails.status == "FAILURE") {
            status = "failure";
          } else if (statusDetails.substatus == "order_received") {
            status = "order_received";
          } else {
            status = "shipped";
          }

          let htmlElement = null;
          htmlElement = this.querySelector(".mm-status-details__order");
          htmlElement.innerHTML = contents.order.name;

          if (carrierName) {
            htmlElement = this.querySelector(".mm-status-details__carrier");
            htmlElement.innerHTML = `
              <div class="mm-subtitle">
                ${carrierName}
              </div>
              <div>
                <a href="${trackingUrl}" target="_blank" rel="noopener noreferrer">
                  <span aria-hidden="true">${trackingCode}</span>
                  <span class="visually-hidden">
                    Track your shipment with tracking code ${trackingCode}
                  </span>
                </a>
              </div>
            `;
          }

          if (status === "delivered") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);
            this.setTrackingStatus(trackingBar[1], events, OrderTracking.SHIPPED);
            this.setTrackingStatus(trackingBar[2], events, OrderTracking.OUT_FOR_DELIVERY);
            this.setTrackingStatus(trackingBar[4], events, statusDetails.substatus);

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking[statusDetails.substatus];
          } else if (status === "out_for_delivery") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);
            this.setTrackingStatus(trackingBar[1], events, OrderTracking.SHIPPED);
            this.setTrackingStatus(trackingBar[2], events, OrderTracking.OUT_FOR_DELIVERY);

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking.out_for_delivery;
          } else if (status === "fulfilled") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking.fulfilled;
          } else if (status === "shipped") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);
            this.setTrackingStatus(trackingBar[1], events, OrderTracking.SHIPPED);

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking.shipped;
          } else if (status === "delivery_attempted") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);
            this.setTrackingStatus(trackingBar[1], events, OrderTracking.SHIPPED);
            this.setTrackingStatus(trackingBar[2], events, OrderTracking.OUT_FOR_DELIVERY);

            trackingBar[3].classList.remove("mm-hidden");
            this.setTrackingStatus(trackingBar[3], events, OrderTracking.DELIVERED_ATTEMPTED, false);

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking.deliveredAttempted;
          } else if (status === "return_to_sender") {
            this.setTrackingStatus(trackingBar[0], events, OrderTracking.INFORMATION_RECEIVED);
            this.setTrackingStatus(trackingBar[1], events, OrderTracking.SHIPPED);
            this.setTrackingStatus(trackingBar[2], events, OrderTracking.RETURN_TO_SENDER, false);

            const labelEl = trackingBar[2].querySelector(".mm-status-tracking__status-label");
            labelEl.innerHTML = window.orderTracking[OrderTracking.RETURN_TO_SENDER];

            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking[OrderTracking.RETURN_TO_SENDER];
          } else if (status === "order_received") {
            let statusHtmlElement = this.querySelector(".mm-status-details__status");
            statusHtmlElement.innerHTML = window.orderTracking[OrderTracking.ORDER_RECEIVED];
          }
        }
      }

      setTrackingStatus(trackingEl, events, substatus, success = true) {
        const event = events.find((event) => event.substatus == substatus);
        const date = event?.date ? new Date(event?.date) : null;

        const markEl = trackingEl.querySelector(".mm-status-tracking__mark");
        const dateEl = trackingEl.querySelector(".mm-status-tracking__status-date");

        if (success) {
          markEl.classList.add("mm-success");
        } else {
          markEl.classList.add("mm-error");
        }

        if (!date) return;

        dateEl.innerHTML = `
          <span class="mm-date" data-locale="en">
            ${this.enFormatter.format(date)}
          </span>
          <span class="mm-date" data-locale="fr">
            ${this.frFormatter.format(date)}
          </span>
        `;
      }

      hideSpinner() {
        const spinner = this.querySelector(".mm-loading");
        spinner.classList.remove("loading");
      }

      makeDateFormatter(locale) {
        return new Intl.DateTimeFormat(locale, {
          weekday: "long",
          month: "long",
          day: "numeric",
        });
      }

      async queryOrderStatus(query) {
        const host = window.location.host;
        const baseUrl = `https://${host}`;
        const endpoint = `${baseUrl}/apps/wonderment/graphql`;

        const payload = {
          query: OrderTracking.QUERY,
          variables: {
            query: query,
          },
        };

        const headers = { "Content-Type": "application/json" };
        const response = await fetch(endpoint, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(payload),
        });

        return await response.json();
      }

      redirectToMalomoTrackingPage() {
        const { pathname, search, host, protocol } = window.location;

        if (pathname.endsWith("/tracking")) return;

        const cleanPath = pathname.replace(/^\//, "");
        const trackingPath = `${cleanPath}ing`;

        const newUrl = `${protocol}//${host}/${trackingPath}${search}`;

        window.location.href = newUrl;
      }

      static INFORMATION_RECEIVED = "information_received";
      static SHIPPED = "package_departed";
      static OUT_FOR_DELIVERY = "out_for_delivery";
      static DELIVERED = "delivered";
      static DELIVERED_ATTEMPTED = "delivery_attempted";
      static RETURN_TO_SENDER = "return_to_sender";
      static ORDER_RECEIVED = "order_received";

      static QUERY = `
        query shipmentSearch($query: String, $authParams: SearchAuthParams) {
          shipmentSearch(query: $query, authParams: $authParams) {
            shipments {
              trackingCode
              trackingUrl
              eta
              carrierName
              statusDetails {
                date
                details
                status
                substatus
              }
              order {
                name
              }
              events {
                date
                status
                substatus
                details
                locationDisplay
                city
                state
                zip
                country
              }
            }
          }
        }
      `;
    }
  );
}
